import React from "react";
import { Box, Container, Typography } from "@mui/material";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import { LAYOUT } from "../../configuration/theme";

const SIZE = 84;

const CATEGORY_IMAGES = {
    women: "static/images/cat-women.png",
    men: "static/images/cat-men.png",
    jeans: "static/images/cat-jeans.png",
    collections: "static/images/cat-collections.png",
    clearance: "static/images/cat-clearance.png",
};

const categoryImage = (category) => {
    if (category.image) return category.image;
    const bundled = CATEGORY_IMAGES[String(category.value).toLowerCase()];
    if (!bundled) return "";
    const { dependency_root } = ConfigurationHelper.getGlobalConfiguration();
    return `${dependency_root}${bundled}`;
};

const SectionKicker = ({ children }) => (
    <Typography
        component="h2"
        sx={{
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "1.4px",
            textTransform: "uppercase",
            color: "#7A736E",
            marginBottom: "14px",
        }}
    >
        {children}
    </Typography>
);

const CategoryCircles = ({ selected, onSelect }) => {
    const categories = ConfigurationHelper.getCategories();

    if (!categories.length) {
        return null;
    }

    return (
        <Container sx={{ px: LAYOUT.pagePad, pt: "26px" }}>
            <SectionKicker>Browse by category</SectionKicker>
            <Box
                sx={{
                    display: "flex",
                    gap: "22px",
                    overflowX: "auto",
                    padding: "8px 0 6px",
                }}
            >
                {categories.map((category) => {
                    const active = selected === category.value;
                    const image = categoryImage(category);
                    return (
                        <Box
                            key={category.value}
                            component="button"
                            type="button"
                            aria-pressed={active}
                            onClick={() => onSelect(active ? "" : category.value)}
                            sx={{
                                flex: "none",
                                width: "96px",
                                border: 0,
                                background: "transparent",
                                padding: 0,
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "9px",
                            }}
                        >
                            <Box
                                component="span"
                                sx={{
                                    width: `${SIZE}px`,
                                    height: `${SIZE}px`,
                                    borderRadius: "999px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#F5F4F3",
                                    backgroundImage: image ? `url(${image})` : "none",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    fontSize: "22px",
                                    fontWeight: 700,
                                    color: "#7A736E",
                                    boxShadow: active
                                        ? (theme) => `0 0 0 2px ${theme.tvp.accent}`
                                        : "0 0 0 1px #EDE6E1",
                                    transition: "box-shadow 140ms ease, transform 140ms ease",
                                    "&:hover": {
                                        boxShadow: (theme) => `0 0 0 2px ${theme.tvp.accent}`,
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                {!image && (category.label || "").trim().charAt(0).toUpperCase()}
                            </Box>
                            <Box
                                component="span"
                                sx={{
                                    fontSize: "12.5px",
                                    lineHeight: 1.25,
                                    textAlign: "center",
                                    color: "#1A1A1A",
                                    fontWeight: active ? 700 : 600,
                                }}
                            >
                                {category.label}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Container>
    );
};

export default CategoryCircles;
